import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  form: {
    contentMatchingMaxBiddingAmount: 300,
    customContentMatchingMaxBiddingAmountYn: 'Y',
  },
  preview: {
    contentMatchingMaxBiddingAmount: 300,
    customContentMatchingMaxBiddingAmountYn: 'Y',
  },
}

export const showAdGroupContentMatchingMaxBiddingAmountEdit = createAxiosThunk(
  'dashboard/showAdGroupContentMatchingMaxBiddingAmountEdit',
  adGroupIds => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupContentMatchingMaxBiddingAmountEdit =
  createAxiosThunk(
    'dashboard/updateAdGroupContentMatchingMaxBiddingAmountEdit',
    (noArgs, { getState }) => {
      const {
        adGroups,
        preview: {
          contentMatchingMaxBiddingAmount,
          customContentMatchingMaxBiddingAmountYn,
        },
      } =
        getState().dashboard.operation
          .adGroupContentMatchingMaxBiddingAmountEdit
      return api.ad.patchAdGroupsBiddingStrategy({
        adGroupIds: adGroups.map(({ id }) => id),
        changeContentMatchingMaxBiddingAmount: 'Y',
        contentMatchingMaxBiddingAmount,
        customContentMatchingMaxBiddingAmountYn,
        changeMaxBiddingAmount: 'N',
        changePcWeight: 'N',
        changeMobileWeight: 'N',
        changeKeywordExtensionWeight: 'N',
      })
    }
  )
const adGroupContentMatchingMaxBiddingAmountEditSlice = createSlice({
  name: 'dashboard/adGroupContentMatchingMaxBiddingAmountEditSlice',
  initialState,

  reducers: {
    hideAdGroupContentMatchingMaxBiddingAmountEdit: () => initialState,
    setCustomContentMatchingMaxBiddingAmountYn: (state, { payload }) => {
      state.form.customContentMatchingMaxBiddingAmountYn = payload
    },
    showPreview: (state, { payload }) => {
      state.preview.customContentMatchingMaxBiddingAmountYn =
        state.form.customContentMatchingMaxBiddingAmountYn
      state.preview.contentMatchingMaxBiddingAmount = payload
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(
      showAdGroupContentMatchingMaxBiddingAmountEdit.pending,
      state => {
        state.isLoading = true
        state.visible = true
      }
    )

    builder.addCase(
      showAdGroupContentMatchingMaxBiddingAmountEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showAdGroupContentMatchingMaxBiddingAmountEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(({ id, name, biddingStrategy }) => ({
          id,
          name,
          biddingStrategy,
        }))
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every((value, index, array) => {
            const current = value.biddingStrategy
            const other = array[0].biddingStrategy
            return (
              current?.contentMatchingMaxBiddingAmount ===
                other?.contentMatchingMaxBiddingAmount &&
              current?.customContentMatchingMaxBiddingAmountYn ===
                other?.customContentMatchingMaxBiddingAmountYn
            )
          })

        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const {
            biddingStrategy: {
              contentMatchingMaxBiddingAmount,
              customContentMatchingMaxBiddingAmountYn,
            },
          } = first
          state.form.contentMatchingMaxBiddingAmount =
            contentMatchingMaxBiddingAmount
          state.form.customContentMatchingMaxBiddingAmountYn =
            customContentMatchingMaxBiddingAmountYn
        }
        state.isLoading = false
      }
    )

    builder.addCase(
      updateAdGroupContentMatchingMaxBiddingAmountEdit.pending,
      state => {
        state.isSubmitting = true
      }
    )

    builder.addCase(
      updateAdGroupContentMatchingMaxBiddingAmountEdit.fulfilled,
      state => {
        state.isSubmitting = false
      }
    )

    builder.addCase(
      updateAdGroupContentMatchingMaxBiddingAmountEdit.rejected,
      state => {
        state.isSubmitting = false
      }
    )
  },
})
export const {
  hideAdGroupContentMatchingMaxBiddingAmountEdit,
  setCustomContentMatchingMaxBiddingAmountYn,
  showPreview,
  hidePreview,
} = adGroupContentMatchingMaxBiddingAmountEditSlice.actions
export default adGroupContentMatchingMaxBiddingAmountEditSlice.reducer
